import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

export default function StoreLocationInput({ values, onChange, disabled }) {
  const { t } = useTranslation()

  return (
    <div className="space-y-3">
      <div>
        <label htmlFor="dt-store-id" className="block text-sm font-medium text-gray-700 mb-1">
          {t("natura_operations.deposit_transfer.store_id")}
        </label>
        <input
          id="dt-store-id"
          type="text"
          inputMode="numeric"
          aria-label="store_id"
          value={values.store_id || ""}
          disabled={disabled}
          onChange={(e) => onChange({ store_id: e.target.value })}
          className="w-full font-mono text-sm border border-gray-300 rounded p-2 disabled:bg-gray-100"
        />
      </div>

      <div>
        <label htmlFor="dt-location" className="block text-sm font-medium text-gray-700 mb-1">
          {t("natura_operations.deposit_transfer.warehouse_location")}
        </label>
        <input
          id="dt-location"
          type="text"
          aria-label="warehouse_location"
          value={values.warehouse_location || ""}
          disabled={disabled}
          onChange={(e) => onChange({ warehouse_location: e.target.value })}
          className="w-full font-mono text-sm border border-gray-300 rounded p-2 disabled:bg-gray-100"
        />
      </div>

      <p className="text-xs text-gray-500" data-testid="dt-store-location-lost-note">
        {t("natura_operations.deposit_transfer.store_location_lost_note")}
      </p>
    </div>
  )
}

StoreLocationInput.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

StoreLocationInput.defaultProps = {
  disabled: false,
}
